import React from 'react';
import { usePermissions } from 'utils/usePermissions';

interface ICAMProtectedProps {
	children: React.ReactNode;
	branchId?: string | null;
	fallback?: React.ReactNode;
}

/**
 * Component that only renders ICAM content for admin-manager users
 * Staff and regular managers will not see ICAM content
 * If branchId is provided, checks if user has admin-manager role for that specific branch
 */
const ICAMProtected: React.FC<ICAMProtectedProps> = ({
	children,
	branchId,
	fallback = null,
}) => {
	const { hasICAMAccess } = usePermissions(branchId);

	if (!hasICAMAccess()) {
		return <>{fallback}</>;
	}

	return <>{children}</>;
};

export default ICAMProtected;
